import { apiBase } from '@/api/instance';
import Qs from 'qs';

export const SearchGender = (params) => {
  return apiBase({
    url: `/cats/genders`,
    method: 'get',
    params: params,
    paramsSerializer: (params) => {
      return Qs.stringify(params, { arrayFormat: 'repeat' });
    }
  });
};

export const StoreGender = (params) => {
  return apiBase({
    url: '/cats/genders',
    method: 'post',
    data: params
  });
};

export const ShowGender = ({ id }) => {
  return apiBase({
    url: `/cats/genders/${id}`,
    method: 'get'
  });
};

export const UpdateGender = (params) => {
  return apiBase({
    url: `/cats/genders/${params.id}`,
    method: 'put',
    data: params
  });
};

export const DestroyGender = ({ id }) => {
  return apiBase({
    url: `/cats/genders/${id}`,
    method: 'delete'
  });
};
